import { apiHelpers } from './api';

// Creates the Standard plan subscription and sends the merchant to Shopify's
// approval page. That page lives in the admin, outside the app iframe, so it is
// opened at the top level (App Bridge v4 intercepts window.open for admin URLs).
// Resolves true if the shop turned out to be subscribed already.
export async function startSubscription() {
  const { data } = await apiHelpers.startSubscription();
  if (data.active) return true;
  window.open(data.confirmationUrl, '_top');
  return false;
}

// "$10.00 / month" from the subscription's recurring price, or null if Shopify
// didn't report one.
export function formatPlanPrice(plan) {
  if (!plan || plan.price == null || !plan.currencyCode) return null;
  const amount = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: plan.currencyCode,
  }).format(plan.price);
  const period = plan.interval === 'ANNUAL' ? 'year' : 'month';
  return `${amount} / ${period}`;
}
